import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Modal from 'react-modal';
import Notification from './Notification';
import './Shop.css';
import ProductCard from './ProductCard';
import { isVisible } from '@testing-library/user-event/dist/utils';
import { type } from '@testing-library/user-event/dist/type';
import { productsData } from './productsData';

Modal.setAppElement('#root');
export default class Home extends Component { 

  // формирование способа получения данных из базы
  constructor(props) {
    super(props);
    this.state = {
      basket: [],
      favorite: [],
      basketCounts: {},
      totalBasketCount: 0,
      products: null,
      selectedSize: {},
      filters: {
        clothes: false,
        other: false
      },
      sort: '',
      visibleProductCardRows: {},
      isAddingToBasket: {},
      totalCost: 0,
      isModalOpen: false,
      cardNumber: '',
      cardExpiry: '',
      cardCVV: '',
      cardEmail: '',
      errors: {},
      notification: {
        message: '',
        type: '',
        isVisible: false
      }
    }; 
    this.onProduct=this.onProduct.bind(this);
    this.handleSizeChange = this.handleSizeChange.bind(this);
    this.addToBasket = this.addToBasket.bind(this);
  }

  componentDidMount() {
    const visibleProductCardRows = {};
    productsData.forEach(product => {
        visibleProductCardRows[product.id] = false;
    });

    this.setState({ 
        products: productsData, 
        visibleProductCardRows: visibleProductCardRows 
    });

    const params = new URLSearchParams(window.location.search);
    const productId = params.get('product');
    const stateString = params.get('state');
    
    if (stateString) {
        try {
            const state = JSON.parse(decodeURIComponent(stateString));
            if (productId) {
                this.setState(prevState => ({
                    visibleProductCardRows: { ...prevState.visibleProductCardRows, [productId]: true },
                    selectedSize: { ...prevState.selectedSize, [productId]: state.selectedSize }
                }));
            }
        } catch (e) { console.error("Ошибка URL state", e); }
    }

    this.csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    this.userToken = localStorage.getItem('userToken');
    this.fetchBasket();
    // this.fetchFavorites();
  }

  letsanimate() {
    const elements = document.querySelectorAll('.product_card');
    const observer = new IntersectionObserver(entries => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add('visible');
          }, index * 300);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1
    });
    elements.forEach((element) => {
      observer.observe(element);
    })
  };

  fetchBasket=()=>{
    fetch('http://localhost:8080/basket', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(response.status);
      }
      return response.json();
    })
    .then(data => {
      const selectedSizeState = {...this.state.selectedSize};
      const basketCounts = {...this.state.basketCounts};
      const visibleProductCardRows = { ...this.state.visibleProductCardRows };
      // if (productId && selectedSize && basketCount) {
      //   selectedSizeState[productId] = selectedSize;
      //   basketCounts[productId] = basketCount;
      // }
      data.forEach(item => {
        if (!basketCounts[item.id]) {
          basketCounts[item.id] = item.count;
        }
        if (!selectedSizeState[item.productid]) {
          selectedSizeState[item.productid] = item.size;
        }
        visibleProductCardRows[item.productid] = true;
      });
      const totalBasketCount=Object.values(basketCounts).reduce((total, count)=>total+count,0);
      this.setState({
        basket: data.map(item => ({ id: item.id, productid: item.productid, count: item.count, name: item.name, image: item.image, cost: item.cost, size: item.size })),
        basketCounts: basketCounts,
        visibleProductCardRows: visibleProductCardRows,
        selectedSize: selectedSizeState,
        totalBasketCount
      });
    })
    .catch(error => {
      console.error('Error fetching products:', error.message);
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedSize!==this.state.selectedSize) {
    };
    if (prevState.basketCounts!==this.state.basketCounts || prevState.basket!==this.state.basket) {
      const totalBasketCount=this.getTotalBasketCount();
      this.setState({ totalBasketCount });
    };
    Object.keys(this.state.visibleProductCardRows).forEach(id => {
      const isVisible = this.state.visibleProductCardRows[id];
      const wasVisible = prevState.visibleProductCardRows[id];
      const isInBasket = this.state.basket.some(item => item.productid === parseInt(id));
      const wasInBasket = prevState.basket.some(item => item.productid === parseInt(id));
      const isAdding = this.state.isAddingToBasket[id];
  
      if (isVisible && !wasVisible && !isInBasket && !isAdding) {
        this.addToBasket(parseInt(id));
      }
      if (prevState.basket !== this.state.basket || prevState.basketCounts !== this.state.basketCounts) {
        this.calculateTotalCost();
      }
    });
  }

  clickSize=(size, productId)=> {
    if (this.state.selectedSize[productId]!==size) {
      this.setState(prevState=>({
        selectedSize: {...prevState.selectedSize, [productId]: size},
      }),()=>{
        console.log(`Updated size for product ${productId} to ${size}`);
      });
    }
  }
  
  updateBasketItemSize = (productId, size) => {
    const existingItem = this.state.basket.find(item => item.productid === productId);
    if (existingItem) {
      fetch(`http://localhost:8080/basket/${existingItem.id}`, {
        method: 'PUT',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.csrfToken,
          'Authorization': `Bearer ${this.userToken}`,
        },
        credentials: 'include',
        body: JSON.stringify({ count: existingItem.count, size: size })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .then(()=>{
        console.log('Basket item size updated successfully');
      })
      .catch(error=>{
        console.error('Error updating basket item size: ', error.message);
      });
    }
  }

  increaseProductCount = (productId) => {
    this.updateProductCount(productId, 1);
  }

  decreaseProductCount = (productId) => {
    this.updateProductCount(productId, -1);
  }

  updateProductCount = (productId, change) => {
    if (isNaN(productId)) {
      console.error('Invalid productId:', productId);
      return;
    }
    const currentCount = this.state.basketCounts[productId] || 0;
    const newCount = currentCount + change;
  
    if (newCount < 0) return;
  
    if (newCount === 0) {
      fetch(`http://localhost:8080/basket/${productId}`, {
        method: 'DELETE',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.csrfToken,
          'Authorization': `Bearer ${this.userToken}`,
        },
        credentials: 'include'
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .then(() => {
        this.setState(prevState => {
          const newBasket = prevState.basket.filter(item => item.id !== productId);
          const { [productId]: removed, ...newBasketCounts } = prevState.basketCounts;
          return {
            basket: newBasket,
            basketCounts: newBasketCounts,
            visibleProductCardRows: { ...prevState.visibleProductCardRows, [productId]: false }
          };
        });
      })
      .catch(error => {
        console.error('Error removing product from basket:', error.message);
      });
    } else {
      fetch(`http://localhost:8080/basket/${productId}`, {
        method: 'PUT',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.csrfToken,
          'Authorization': `Bearer ${this.userToken}`,
        },
        credentials: 'include',
        body: JSON.stringify({ count: newCount })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .then(() => {
        this.setState(prevState => ({
          basketCounts: { ...prevState.basketCounts, [productId]: newCount }
        }));
      })
      .catch(error => {
        console.error('Error updating product count:', error.message);
      });
    }
  }

  calculateTotalCost = () => {
    const totalCost = this.state.basket.reduce((acc, item) => {
      const count = this.state.basketCounts[item.id] || 1;
      return acc + (item.cost * count);
    }, 0);
    this.setState({ totalCost });
  }

  addToBasket = (productId, needs) => {
    const selectedSize = this.state.selectedSize[productId] || (needs === 'clothes' ? 'XXL' : null);
    const typeId = needs === 'clothes' ? 'clothes' : needs;
  
    if (this.state.isAddingToBasket[productId + selectedSize]) {
      console.log('Already adding to basket, returning early:', productId);
      return;
    }
  
    this.setState(prevState => ({
      isAddingToBasket: { ...prevState.isAddingToBasket, [productId + selectedSize]: true }
    }));
  
    const existingItem = this.state.basket.find(item => item.productid === productId && (item.size === selectedSize || needs !== 'clothes'));
  
    if (existingItem) {
      const newCount = this.state.basketCounts[existingItem.id] + 1;
      fetch(`http://localhost:8080/basket/${existingItem.id}`, {
        method: 'PUT',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.csrfToken,
          'Authorization': `Bearer ${this.userToken}`,
        },
        credentials: 'include',
        body: JSON.stringify({ count: newCount, size: selectedSize, type_id: typeId })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .then(() => {
        this.setState(prevState => {
          const updatedBasketCounts = { ...prevState.basketCounts, [existingItem.id]: newCount };
          const totalBasketCount = Object.values(updatedBasketCounts).reduce((total, count) => total + count, 0);
          return {
            basketCounts: updatedBasketCounts,
            isAddingToBasket: { ...prevState.isAddingToBasket, [productId + selectedSize]: false },
            totalBasketCount
          };
        });
      })
      .catch(error => {
        console.error('Error updating product count:', error.message);
        this.setState(prevState => ({
          isAddingToBasket: { ...prevState.isAddingToBasket, [productId + selectedSize]: false }
        }));
      });
    } else {
      const product = this.state.products.find(p => p.id === productId);
      if (!product) {
        console.error('Product not found:', productId);
        return;
      }
      const requestData = {
        product_id: productId,
        count: 1,
        image: product.image,
        name: product.name,
        cost: product.cost,
        size: selectedSize,
        type_id: typeId
      };
      fetch('http://localhost:8080/basket', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.csrfToken,
          'Authorization': `Bearer ${this.userToken}`,
        },
        credentials: 'include',
        body: JSON.stringify(requestData)
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .then(responseData => {
        if (!responseData.success) {
          throw new Error('Server did not process the request successfully');
        }
        const newBasketItem = {
          id: responseData.newItem.id,
          productid: productId,
          count: 1,
          image: product.image,
          name: product.name,
          cost: product.cost,
          size: selectedSize,
          type_id: typeId
        };
        this.setState(prevState => {
          const updatedBasket = [...prevState.basket, newBasketItem];
          const updatedBasketCounts = { ...prevState.basketCounts, [newBasketItem.id]: 1 };
          const totalBasketCount = Object.values(updatedBasketCounts).reduce((total, count) => total + count, 0);
          return {
            basket: updatedBasket,
            basketCounts: updatedBasketCounts,
            isAddingToBasket: { ...prevState.isAddingToBasket, [productId + selectedSize]: false },
            visibleProductCardRows: { ...prevState.visibleProductCardRows, [productId]: true },
            totalBasketCount
          };
        });
      })
      .catch(error => {
        console.error('Error adding to basket:', error.message);
        this.setState(prevState => ({
          isAddingToBasket: { ...prevState.isAddingToBasket, [productId + selectedSize]: false }
        }));
      });
    }
  }  
  
  getTotalBasketCount = () => {
    const { basketCounts } = this.state;
  
    const total = Object.values(basketCounts).reduce((total, count) => {
      return total + count;
    }, 0);
  
    return total;
  }
  
  calculateTotalBasketCount = (basketCounts) => {
    const total = Object.values(basketCounts).reduce((total, count) => total + count, 0);
    return total;
  }
  
  removeFromBasket = (id) => {
    fetch(`http://localhost:8080/basket/${id}`, {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrfToken,
        'Authorization': `Bearer ${this.userToken}`,
      },
      credentials: 'include',
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      return response.json();
    })
    .then(() => {
      this.setState(prevState => {
        const newBasket = prevState.basket.filter(item => item.id !== id);
        const newBasketCounts = { ...prevState.basketCounts };
        newBasket.forEach(item => delete newBasketCounts[id]);
        return {
          basket: newBasket,
          basketCounts: newBasketCounts,
          visibleProductCardRows: { ...prevState.visibleProductCardRows, [prevState.basket.find(item => item.id === id).productid]: false }
        };
      });
    })
    .catch(error => {
      console.error('Error removing product from basket:', error.message);
    });
  }  
  
  onProduct = (event, productId, selectedSize = null, basketCount = null) => {
    event.preventDefault();
    const product = this.state.basket.find(item => item.productid === productId);
    const state = {
      selectedSize: selectedSize || this.state.selectedSize[productId] || 'XXL',
      basketCount: product ? this.state.basketCounts[product.id] : basketCount || 0 // Используем существующий basketCount или 0 по умолчанию
    };
    const stateString = encodeURIComponent(JSON.stringify(state));
    window.location.href = `http://localhost:3000/shop?product=${encodeURIComponent(productId)}&state=${stateString}`;
  }  

  handleSizeChange = (size, productId) => {
    this.setState(prevState=>({
      selectedSize: {...prevState.selectedSize, [productId]: size}
    }));
  }
  
  toggleProductCardRow = (id) => { 
    this.setState(prevState => { 
      const isVisible = prevState.visibleProductCardRows[id]; 
      const shouldToggleVisibility=!isVisible||this.state.basket.some(item=>item.productid===id);
      const visibleProductCardRows = { 
        ...prevState.visibleProductCardRows, 
        [id]: shouldToggleVisibility
      }; 
      return { visibleProductCardRows }; 
    });
  }

  toggleFavorite=(productId)=>{
    const isFavorite=this.state.favorite.some(item=>item.productid===productId);
    fetch(`http://localhost:8080/favorite/${productId}`, {
      method: isFavorite ? 'DELETE' : 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrfToken,
        'Authorization': `Bearer ${this.userToken}`,
      },
      credentials: 'include',
    })
    .then(response=>{
      if (!response.ok) {
        throw new Error(response.status);
      }
      return response.json();
    })
    .then(()=>{
      this.setState(prevState => {
        if (isFavorite) {
          return {
            favorite: prevState.favorite.filter(item=>item.productid!==productId)
          };
        } else {
          const product=this.state.products.find(p=>p.id===productId);
          const newFavorite={
            id: null,
            productid: productId,
            image: product ? product.image : '',
            cost: product ? product.cost : 0,
            name: product ? product.name : ''
          };
          return {
            favorite: [...prevState.favorite, newFavorite]
          };
        }
      });
    })
    .catch(error=>{
      console.error('Error updating favorite:', error.message);
    })
  }

  handleFilterChange=(event)=>{
    const { name, checked } = event.target;
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        [name]: checked
      }
    }), this.updateVisibleProducts);
  }

  handleSortChange=(event)=>{
    const { value }=event.target;
    this.setState({sort: value}, this.updateVisibleProducts);
  }

  applyFilters=(products)=>{
    const { clothes, other }=this.state.filters;
    if (!clothes&&!other) {
      this.letsanimate();
      return products;
    }
    return products.filter(product=>{
      if (clothes&&product.needs === 'clothes') {
        return true;
      }
      if (other&&product.needs === 'other') {
        return true;
      }
      return false;
    });
  }

  applySort=(products)=>{
    const {sort}=this.state;
    if (sort==='asc') {
      return products.sort((a,b)=>a.cost-b.cost);
    } 
    if (sort==='desc') {
      return products.sort((a,b)=>b.cost-a.cost);
    }
    return products;
  }
  
  updateVisibleProducts=()=>{
    const filteredProducts=this.applyFilters(this.state.products);
    const sortedProducts=this.applySort(filteredProducts);
    this.setState({visibleProducts: sortedProducts},this.letsanimate);
  }
  
  toggleModal=()=>{
    this.setState(prevState=>({
      isModalOpen: !prevState.isModalOpen,
      errors: {}
    }));
  }

  handleInputChange=(e)=>{
    const { name, value } = e.target;
    this.setState({
      [name]: value
    });
  }

  handleInputBlur=(e)=>{
    const { name, value } = e.target;
    this.validateInput(name,value);
  }

  validateInput=(name,value)=>{
    const { errors }=this.state;
    const newErrors={...errors};
    switch (name) {
      case 'cardNumber':
        newErrors.cardNumber=/^\d{16}$/.test(value)?'':'Введите правильный номер карты (16 цифр)';
        break;
      case 'cardExpiry':
        newErrors.cardExpiry=/^(0[1-9]|1[0-2])\/?([0-9]{2})$/.test(value)?'':'Введите правильный срок действия карты (ММ/ГГ)';
        break;
      case 'cardCVV':
        newErrors.cardCVV=/^[0-9]{3,4}$/.test(value)?'':'Введите правильный CVV (3 или 4 цифры)';
        break;
      case 'cardEmail':
        newErrors.cardEmail=/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)?'':'Введите правильный адрес электронной почты';
        break;
      default:
        break;
    }
    this.setState({errors:newErrors});
  }

  validateInputs=()=>{
    const { cardNumber, cardExpiry, cardCVV, cardEmail } = this.state;
    const errors={};
    errors.cardNumber = /^\d{16}$/.test(cardNumber)?'':'Введите правильный номер карты (16 цифр)';
    errors.cardExpiry = /^(0[1-9]|1[0-2])\/?([0-9]{2})$/.test(cardExpiry)?'':'Введите правильный срок действия карты (ММ/ГГ)';
    errors.cardCVV = /^[0-9]{3,4}$/.test(cardCVV)?'':'Введите правильный CVV (3 или 4 цифры)';
    errors.cardEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cardEmail)?'':'Введите правильный адрес электронной почты';

    this.setState({ errors });
    return Object.keys(errors).every(key=>errors[key]==='');
  }

  handlePayment = () => {
    if (this.validateInputs()) {
      const userToken = localStorage.getItem('userToken');
  
      this.getUserId(userToken)
        .then(userId => {
          const purchasePromises = this.state.basket.map(item => {
            const purchaseData = {
              user_id: userId,
              item_id: item.productid,
              purchase_date: new Date().toISOString(),
              quantity: item.count,
              total_price: item.cost * item.count,
              size: item.size || null
            };
  
            return fetch('http://localhost:8080/purchases/create', {
              method: 'POST',
              headers: {
                'Authorization': `Bearer ${userToken}`,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(purchaseData)
            })
            .then(response => response.json().then(data => {
              if (!response.ok) {
                throw new Error(data.message || response.statusText);
              }
              return data;
            }))
            .catch(error => {
              console.error('Ошибка при создании покупки:', error.message);
              throw new Error('Ошибка при создании покупки: ' + error.message);
            });
          });
  
          return Promise.all(purchasePromises);
        })
        .then(() => {
          this.setState({
            basket: [],
            basketCounts: {},
            totalBasketCount: 0,
            totalCost: 0,
            notification: {
              message: 'Оплата прошла успешно',
              type: 'success',
              isVisible: true
            }
          });
          this.toggleModal();
        })
        .catch(error => {
          console.error('Ошибка при оплате:', error.message);
          this.setState({
            notification: {
              message: 'Ошибка при оплате: ' + error.message,
              type: 'error',
              isVisible: true
            }
          });
        });
    }
  }
  
  getUserId = (token) => {
    return fetch(`http://localhost:8080/users/get-user-id?token=${token}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        return data.user_id;
      } else {
        throw new Error(data.message);
      }
    });
  }
  
  closeNotification=()=>{
    this.setState({
      notification: {
        message: '',
        type: '',
        isVisible: false
      }
    });
  }

  render() {
    const { errors, notification, products, filters, sort } = this.state;
    const params = new URLSearchParams(window.location.search);
    const act = params.get('action'); 
    const takeproduct = params.get('product');
    const stateString=params.get('state');
    const state=stateString?JSON.parse(decodeURIComponent(stateString)):{};
    const selectedSize = this.state.selectedSize[takeproduct] || state.selectedSize || 'XXL';
    const basketCount=this.state.basketCounts[takeproduct] || state.basketCount || 1;
    let filteredProducts=this.applyFilters(this.state.products);
    filteredProducts=this.applySort(filteredProducts);
    const totalBasketCount=this.state.totalBasketCount;

    const displayProducts = this.state.visibleProducts || this.applySort(this.applyFilters(products || []));

    if (!takeproduct&&!act) {
    return (
      <div className='main'>
        <section>
          <div className='shoppage'>
            <div className='catalog'>
              <div className='catalog_filters'>
                <div className='filter_filter_row'>
                  <p className='catalogfilters_maintxt'>Фильтры:</p>
                  <div className='catalogfilterpodd'>
                    <input type='checkbox' id='clothesfilter' className='catalogfilters_filter' name='clothes' checked={this.state.filters.clothes} onChange={this.handleFilterChange} />
                    <label className='catalogfilters_text' htmlFor='clothesfilter'>Размерное</label>
                  </div>
                  <div className='catalogfilterpodd'>
                    <input type='checkbox' id='otherfilter' className='catalogfilters_filter' name='other' checked={this.state.filters.other} onChange={this.handleFilterChange} />
                    <label className='catalogfilters_text' htmlFor='otherfilter'>Остальное</label>
                  </div>
                </div>
                <div className='sort_sort_row'>
                  <p className='catalogfilters_maintxt2'>Сортировка по цене:</p>
                  <div className='catalogsortpodd'>
                    <input type='radio' id='sortasc' className='catalogsorts_sort' name='sort' checked={this.state.sort==='asc'} onChange={this.handleSortChange} value='asc' />
                    <label className='catalogfilters_text' htmlFor='sortasc'>По возрастанию</label>
                  </div>
                  <div className='catalogsortpodd'>
                    <input type='radio' id='sortdesc' className='catalogsorts_sort' name='sort' checked={this.state.sort==='desc'} onChange={this.handleSortChange} value='desc' />
                    <label className='catalogfilters_text' htmlFor='sortdesc'>По убыванию</label>
                  </div>
                  <div className='catalogsortpodd'>
                    <input type='radio' id='sortdescasc' className='catalogsorts_sort' name='sort' checked={this.state.sort===''} onChange={this.handleSortChange} value='' />
                    <label className='catalogfilters_text' htmlFor='sortdescasc'>Без сортировки</label>
                  </div>
                </div>
              </div>
              <div className='products'>
                {filteredProducts !== null ? 
                filteredProducts.map(elem => 
                  <div className='product_card' key={elem.id}>
                    <Link to='' className='product_click' onClick={(event) => this.onProduct(event, elem.id, this.state.selectedSize[elem.id])}>
                      <img className='product_card_img' src={elem.image} alt={elem.name} />
                    </Link>
                    <div className='productcard_info'>
                      <div className='product_card_p_row'>
                        <p className='product_card_p'>{elem.name.split(' ')[0]}</p>
                        <p className='product_card_cost'>{elem.cost}</p>
                      </div>
                      {elem.needs==='clothes'&&(
                        <div className='productcard_size'>
                          <p className='razzzzz'>Размер:</p>
                          {['S','L','XL','XXL'].map(sizeOption => (
                            <div className='cardinput' key={`${elem.id}_${sizeOption}`}>
                              <input 
                              id={`cardinputradiosize_${elem.id}_${sizeOption}`}
                              type='radio'
                              name={`size_${elem.id}`}
                              value={sizeOption}
                              checked={this.state.selectedSize[elem.id]===sizeOption}
                              onChange={()=>this.handleSizeChange(sizeOption,elem.id)}
                              />
                              <label key={sizeOption} htmlFor={`cardinputradiosize_${elem.id}_${sizeOption}`}>{sizeOption}</label>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    <div className='product_card_buy_row'>
                      {this.state.basket.some(item=>item.productid===elem.id&&(item.size===this.state.selectedSize[elem.id] || elem.needs !== 'clothes'))?(
                        this.state.basket.filter(item=>item.productid===elem.id&&(item.size===this.state.selectedSize[elem.id] || elem.needs !== 'clothes')).map(item=>(
                          <div className='productcardrow' key={item.id}>
                              <p className='product_card_buy_minus' onClick={() => this.updateProductCount(item.id,-1)}>-</p>
                              <p className='product_card_buy_count'>{this.state.basketCounts[item.id]||1}</p>
                              <p className='product_card_buy_plus' onClick={() => this.updateProductCount(item.id,1)}>+</p>
                          </div>
                        ))
                      ) : (
                          <button 
                              key={elem.id}
                              className='product_card_buy_button' 
                              onClick={() => this.addToBasket(elem.id, elem.needs)} 
                              disabled={this.state.isAddingToBasket[elem.id + this.state.selectedSize[elem.id]]}
                          >
                              в корзину
                          </button>
                      )}
                      <img
                          className='product_card_buy_unclick' 
                          src={this.state.favorite.some(item=>item.productid===elem.id) ? 'https://i.yapx.ru/YLVFN.png' : 'https://i.yapx.ru/YLVFO.png'} 
                          onClick={() => this.toggleFavorite(elem.id)} alt='Избранное' 
                      />
                  </div>
                  </div>
                ) : null}
              </div>
              <div className='catalog_next'>
                <div className='catalognext_col'>
                  <Link to='#' onClick={favvs}><img className='catalognextcol_img fav' src='https://i.yapx.ru/YLUeR.png' alt='Избранное' /></Link>
                  <p className='catalognextcol_counterlike'>{this.state.favorite ? this.state.favorite.length : 0}</p>
                </div>
                <div className='catalognext_col'>
                  <Link to='#' onClick={basss}><img className='catalognextcol_img bas' src='https://i.yapx.ru/YLTvN.png' alt='Корзина' /></Link>
                  <p className='catalognextcol_countercorz'>{totalBasketCount}</p>
                </div>
              </div>
            </div>
            <div className='footer'>
              <div className='footerleft'>
                <div className='footerleftline'>
                  <Link to="" className='footerleftlinechapters vk' onClick={(e) => this.selectsong(e,'https://vk.com/lampabikt')} />
                  <Link to=""  className='footerleftlinechapters yt' onClick={(e) => this.selectsong(e,'https://www.youtube.com/channel/UCpYDcaEQw6RQ-t_3CGidJuQ')} />
                  <Link to=""  className='footerleftlinechapters tg' onClick={(e) => this.selectsong(e,'https://t.me/lampabikt')} />
                  <Link to=""  className='footerleftlinechapters tt' onClick={(e) => this.selectsong(e,'https://www.tiktok.com/@lampabikt?is_from_webapp=1&sender_device=pc')} />
                </div>
                <div className='footerleftname'>
                  <p className='footerleftnametext'>
                    лампабикт.
                  </p>
                </div>
              </div>
              <div className='footercenter'>
                <a className='footercenterimg' />
              </div>
              <div className='footerright'>
                <div className='footerrightline'>
                <p className='footerrightlinetext'>ИКОНКИ ОТ <a className='footerrightlinetextlinkus' href='https://icons8.ru/icons' target='_blank' rel='noopener noreferrer'>ICONS8</a></p>
                  <p className='footerrightlinetext'>СВЯЗАТЬСЯ С НАМИ: <a className='link_to_email' href="mailto:lampabikt@gmail.com">LAMPABIKT@GMAIL.COM</a></p>
                  <p className='footerrightlinetext'>МЕНЕДЖЕР: АЛЕКСАНДРА</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )} else if (takeproduct&&!act) {
      if (this.state.products&&takeproduct) {
        const product = this.state.products.find(p => p.id == takeproduct);
        const isInBasket = this.state.basket.some(item=>item.productid===product.id&&(item.size===selectedSize || product.needs !== 'clothes'));

        return ( 
          <div className='main'> 
            <section> 
              <div className='full_card'> 
                <div className='fullcard_product'> 
                  <div className='fullcard_center'> 
                    <div className='fullcard_center_colswith'>
                      {filteredProducts.map(product => ( 
                        <ProductCard 
                          key={product.id} 
                          productId={takeproduct} 
                          product={product} 
                          selectedSize={selectedSize} 
                          isInBasket={isInBasket} 
                          basketCount={basketCount} 
                          updateProductCount={this.updateProductCount} 
                          addToBasket={this.addToBasket} 
                          toggleFavorite={this.toggleFavorite} 
                          clickSize={this.clickSize} 
                          state={this.state} 
                        /> 
                      ))} 
                    </div>
                    <div className='catalog_next2'>
                      <div className='catalognext_col'>
                        <Link to='#' onClick={favvs}><img className='catalognextcol_img fav' src='https://i.yapx.ru/YLUeR.png' alt='Избранное' /></Link>
                        <p className='catalognextcol_counterlike'>{this.state.favorite ? this.state.favorite.length : 0}</p>
                      </div>
                      <div className='catalognext_col'>
                        <Link to='#' onClick={basss}><img className='catalognextcol_img bas' src='https://i.yapx.ru/YLTvN.png' alt='Корзина' /></Link>
                        <p className='catalognextcol_countercorz'>{totalBasketCount}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='footer'>
                  <div className='footerleft'>
                    <div className='footerleftline'>
                      <Link to="" className='footerleftlinechapters vk' onClick={(e) => this.selectsong(e,'https://vk.com/lampabikt')} />
                      <Link to=""  className='footerleftlinechapters yt' onClick={(e) => this.selectsong(e,'https://www.youtube.com/channel/UCpYDcaEQw6RQ-t_3CGidJuQ')} />
                      <Link to=""  className='footerleftlinechapters tg' onClick={(e) => this.selectsong(e,'https://t.me/lampabikt')} />
                      <Link to=""  className='footerleftlinechapters tt' onClick={(e) => this.selectsong(e,'https://www.tiktok.com/@lampabikt?is_from_webapp=1&sender_device=pc')} />
                    </div>
                    <div className='footerleftname'>
                      <p className='footerleftnametext'>
                        лампабикт.
                      </p>
                    </div>
                  </div>
                  <div className='footercenter'>
                    <a className='footercenterimg' />
                  </div>
                  <div className='footerright'>
                    <div className='footerrightline'>
                    <p className='footerrightlinetext'>ИКОНКИ ОТ <a className='footerrightlinetextlinkus' href='https://icons8.ru/icons' target='_blank' rel='noopener noreferrer'>ICONS8</a></p>
                      <p className='footerrightlinetext'>СВЯЗАТЬСЯ С НАМИ: <a className='link_to_email' href="mailto:lampabikt@gmail.com">LAMPABIKT@GMAIL.COM</a></p>
                      <p className='footerrightlinetext'>МЕНЕДЖЕР: АЛЕКСАНДРА</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        )
      }
    } else if (act==='favorite') {
      return (
        <div className='main'>
          <section>
            <div className='favorite'>
              <img className='favoritespi_img' src='https://i.yapx.ru/YMjTG.png' alt='' />
              <div className='favorite_spi'>
                <div className='favorite_block_center'>
                <p className='favoritespi_text'>Избранное:</p>
                <div className='favoritespi_spi'>
                  {this.state.favorite !== null ?
                  this.state.favorite.map(elem=>
                  <div className='favoritespiinter' key={elem.id}>
                    <Link 
                      to='' 
                      className='product_click favorites' 
                      onClick={(event) => {
                        if (!event.defaultPrevented) { // Только если событие не остановлено
                          this.onProduct(event, elem.productid);
                        }
                      }}>
                      <div className='favoritespispi_chapter'>
                        <img className='favoritespispichapter_img' alt={elem.name} src={elem.image} />
                        <p className='favoritespispichapter_txt'>{elem.name}</p>
                        <p className='favoritespispichapter_cost'>{elem.cost}</p>
                        <p className='favoritespispichapter_zn'>₽</p>
                        <img 
                          className='favoritespispichapter_del' 
                          alt="Удалить" 
                          src='https://i.yapx.ru/YMjUP.png' 
                          onClick={(e) => {
                            e.stopPropagation(); // Остановка распространения события
                            e.preventDefault(); // Предотвращение действия по умолчанию
                            this.toggleFavorite(elem.productid);
                          }} 
                        />
                      </div>
                    </Link>
                  </div>
                ) : null}
                </div>
                <div className='catalog_next3'>
                  <div className='catalognext_col'>
                    <Link to='#' onClick={favvs}><img className='catalognextcol_img fav' src='https://i.yapx.ru/YLUeS.png' alt='Избранное' /></Link>
                    <p className='catalognextcol_counterlike'>{this.state.favorite ? this.state.favorite.length : 0}</p>
                  </div>
                  <div className='catalognext_col'>
                    <Link to='#' onClick={basss}><img className='catalognextcol_img bas' src='https://i.yapx.ru/YLTvN.png' alt='Корзина' /></Link>
                    <p className='catalognextcol_countercorz'>{this.getTotalBasketCount()}</p>
                  </div>
                </div>
                </div>
              </div>
              <div className='footer'>
                <div className='footerleft'>
                  <div className='footerleftline'>
                    <Link to="" className='footerleftlinechapters vk' onClick={(e) => this.selectsong(e,'https://vk.com/lampabikt')} />
                    <Link to=""  className='footerleftlinechapters yt' onClick={(e) => this.selectsong(e,'https://www.youtube.com/channel/UCpYDcaEQw6RQ-t_3CGidJuQ')} />
                    <Link to=""  className='footerleftlinechapters tg' onClick={(e) => this.selectsong(e,'https://t.me/lampabikt')} />
                    <Link to=""  className='footerleftlinechapters tt' onClick={(e) => this.selectsong(e,'https://www.tiktok.com/@lampabikt?is_from_webapp=1&sender_device=pc')} />
                  </div>
                  <div className='footerleftname'>
                    <p className='footerleftnametext'>
                      лампабикт.
                    </p>
                  </div>
                </div>
                <div className='footercenter'>
                  <a className='footercenterimg' />
                </div>
                <div className='footerright'>
                  <div className='footerrightline'>
                  <p className='footerrightlinetext'>ИКОНКИ ОТ <a className='footerrightlinetextlinkus' href='https://icons8.ru/icons' target='_blank' rel='noopener noreferrer'>ICONS8</a></p>
                    <p className='footerrightlinetext'>СВЯЗАТЬСЯ С НАМИ: <a className='link_to_email' href="mailto:lampabikt@gmail.com">LAMPABIKT@GMAIL.COM</a></p>
                    <p className='footerrightlinetext'>МЕНЕДЖЕР: АЛЕКСАНДРА</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      )
    } else if (act==='basket') {
      return (
        <div className='main'>
          <section>
            <div className='basket'>
              <img className='basket_img' src='https://i.yapx.ru/YMjTH.png' alt='' />
              <div className='basket_spi'>
                <div className='basket_block_center'>
                <p className='basketspi_text'>Корзина:</p>
                <div className='basket_column'>
                  <div className='basketspi_spi'>
                  {this.state.basket !== null ?
                  this.state.basket.map(elem=>
                    <div className='basketspiinter' key={elem.id}>
                      <Link 
                        to='' 
                        className='product_click baskets' 
                        onClick={(event) => {
                          if (!event.defaultPrevented) { // Только если событие не остановлено
                            this.onProduct(event, elem.productid, elem.size, this.state.basketCounts[elem.id]);
                          }
                        }}>
                        <div className='basketspispi_chapter'>
                          <img className='basketspispichapter_img' alt={elem.name} src={elem.image} />
                          <p className='basketspispichapter_txt'>{elem.name}</p>
                          <p className='basketspispichapter_size'>{elem.size}</p>
                          <div className='productcardrow bas' key={elem.id}>
                            <p className='product_card_buy_minus' onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              this.updateProductCount(elem.id, -1);
                              }}>-</p>
                            <p className='product_card_buy_count'>{this.state.basketCounts[elem.id] || 1}</p>
                            <p className='product_card_buy_plus' onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              this.updateProductCount(elem.id, 1);
                              }}>+</p>
                          </div>
                          <p className='basketspispichapter_cost'>{elem.cost * this.state.basketCounts[elem.id] || 1}</p>
                          <p className='basketspispichapter_zn'>₽</p>
                          <img 
                            className='basketspispichapter_del' 
                            alt="Удалить" 
                            src='https://i.yapx.ru/YMjUP.png' 
                            onClick={(e) => {
                              e.stopPropagation(); // Остановка распространения события
                              e.preventDefault(); // Предотвращение действия по умолчанию
                              this.removeFromBasket(elem.id);
                            }} 
                          />
                        </div>
                      </Link>
                    </div>
                  ) : null}
                  </div>
                  <div className='buybuttonbasketrow'>
                    <div className='finalsum_col'>
                      <p className='buybasketsum'>Итоговая сумма:</p>
                      <p className='summfullbasket'>{this.state.totalCost} ₽</p>
                    </div>
                    <button type='submit' className='buybuttonbasket' onClick={this.toggleModal}>Оформить заказ</button>
                  </div>
                  <Modal isOpen={this.state.isModalOpen} onRequestClose={this.toggleModal} className='basket_modal'>
                    <div className='basketmodal_content'>
                      <h2 className='basketmodal_txt'>Оплатить заказ</h2>
                      <form className='basketmodal_form'>
                        <div className='basketmodal_inputstr'>
                          <label htmlFor='cardNumber' className='basketmodal_label'>Номер карты:</label>
                          <input type='text' maxLength={16} id='cardNumber' className='basketmodal_input' name='cardNumber' value={this.state.cardNumber} onChange={this.handleInputChange} onBlur={this.handleInputBlur} required />
                        </div>
                        {errors.cardNumber&&<p className='basket_error'>{errors.cardNumber}</p>}
                        <div className='basketmodal_inputstr'>
                          <label htmlFor='cardExpiry' className='basketmodal_label'>Срок действия:</label>
                          <input type='text' maxLength={5} id='cardExpiry' className='basketmodal_input' name='cardExpiry' value={this.state.cardExpiry} onChange={this.handleInputChange} onBlur={this.handleInputBlur} required />
                        </div>
                        {errors.cardExpiry&&<p className='basket_error'>{errors.cardExpiry}</p>}
                        <div className='basketmodal_inputstr'>
                          <label htmlFor='cardCVV' className='basketmodal_label'>CVV:</label>
                          <input type='text' maxLength={4} id='cardCVV' className='basketmodal_input' name='cardCVV' value={this.state.cardCVV} onChange={this.handleInputChange} onBlur={this.handleInputBlur} required />
                        </div>
                        {errors.cardCVV&&<p className='basket_error'>{errors.cardCVV}</p>}
                        <div className='basketmodal_inputstr'>
                          <label htmlFor='cardEmail' className='basketmodal_label'>Email для квитанции:</label>
                          <input type='text' id='cardEmail' className='basketmodal_input' name='cardEmail' value={this.state.cardEmail} onChange={this.handleInputChange} onBlur={this.handleInputBlur} required />
                        </div>
                        {errors.cardEmail&&<p className='basket_error'>{errors.cardEmail}</p>}
                        <button type='button' onClick={this.handlePayment} className='basketmodal_button_pay'>Оплатить</button>
                        </form>
                      <button onClick={this.toggleModal} className='basketmodal_button_close'>Отмена</button>
                    </div>
                  </Modal>
                  {notification.isVisible&&(
                    <Notification message={notification.message} type={notification.type} onClose={this.closeNotification} />
                  )}
                </div>
                <div className='catalog_next4'>
                  <div className='catalognext_col'>
                    <Link to='#' onClick={favvs}><img className='catalognextcol_img fav' src='https://i.yapx.ru/YLUeR.png' alt='Избранное' /></Link>
                    <p className='catalognextcol_counterlike'>{this.state.favorite ? this.state.favorite.length : 0}</p>
                  </div>
                  <div className='catalognext_col'>
                    <Link to='#' onClick={basss}><img className='catalognextcol_img bas' src='https://i.yapx.ru/YLTvO.png' alt='Корзина' /></Link>
                    <p className='catalognextcol_countercorz'>{this.getTotalBasketCount()}</p>
                  </div>
                </div>
                </div>
              </div>
              <div className='footer'>
                <div className='footerleft'>
                  <div className='footerleftline'>
                    <Link to="" className='footerleftlinechapters vk' onClick={(e) => this.selectsong(e,'https://vk.com/lampabikt')} />
                    <Link to=""  className='footerleftlinechapters yt' onClick={(e) => this.selectsong(e,'https://www.youtube.com/channel/UCpYDcaEQw6RQ-t_3CGidJuQ')} />
                    <Link to=""  className='footerleftlinechapters tg' onClick={(e) => this.selectsong(e,'https://t.me/lampabikt')} />
                    <Link to=""  className='footerleftlinechapters tt' onClick={(e) => this.selectsong(e,'https://www.tiktok.com/@lampabikt?is_from_webapp=1&sender_device=pc')} />
                  </div>
                  <div className='footerleftname'>
                    <p className='footerleftnametext'>
                      лампабикт.
                    </p>
                  </div>
                </div>
                <div className='footercenter'>
                  <a className='footercenterimg' />
                </div>
                <div className='footerright'>
                  <div className='footerrightline'>
                  <p className='footerrightlinetext'>ИКОНКИ ОТ <a className='footerrightlinetextlinkus' href='https://icons8.ru/icons' target='_blank' rel='noopener noreferrer'>ICONS8</a></p>
                    <p className='footerrightlinetext'>СВЯЗАТЬСЯ С НАМИ: <a className='link_to_email' href="mailto:lampabikt@gmail.com">LAMPABIKT@GMAIL.COM</a></p>
                    <p className='footerrightlinetext'>МЕНЕДЖЕР: АЛЕКСАНДРА</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      )
    }
  };
};

const nnow='http://localhost:3000/shop';
const favvs=(event)=> {
  window.location.href = nnow.replace('#', '') + '?action=favorite';
};
const basss=(event)=> {
  window.location.href = nnow.replace('#', '') + '?action=basket';
};